import angular from 'angular'

import GraphQL from '../GraphQL';

export default class Notificacoes {
    static get notificacaoFields() {
        return `
            id
            tipo
            titulo
            conteudo
            temConteudoAdicional
            lida
            insertedAt
            anexos {
                id
                nome
                ref
            }
        `
    }

    static get tarefaFields() {
        return `
            id
            titulo
            status
            progresso
            lida
            insertedAt
        `
    }

    static get $inject() {
        return ['gql', 'downloadService'];
    }

    /**
     * 
     * @param {GraphQL} gql 
     */
    constructor(gql, downloadService) {
        this.gql = gql;
        this.downloadService = downloadService;
    }

    listNotificacoesAndTarefas(notificacaoFilter = {}, tarefaFilter = {}) {
        const query = gql`
            query ListNotificacoesAndTarefas($notificacaoFilter: NotificacaoFilter, $tarefaFilter: TarefaFilter) {
                usuarioAtual {
                    id
                    notificacoes(filter: $notificacaoFilter) {
                        ${Notificacoes.notificacaoFields}
                    }
                    tarefas(filter: $tarefaFilter) {
                        ${Notificacoes.tarefaFields}
                    }
                }
            }
        `

        return this.gql
            .query(query, { notificacaoFilter, tarefaFilter })
            .then(({ usuarioAtual: { notificacoes, tarefas } }) => ({ notificacoes, tarefas }));
    }

    countNotificacoesAndTarefasNotRead() {
        const query = gql`
        query CountNotificacoesAndTarefasNotRead {
            usuarioAtual {
                id
                count: countNotificacoesAndTarefasNotRead
            }
        }
        `

        return this.gql
            .query(query)
            .then(({ usuarioAtual }) => usuarioAtual.count)
    }

    markNotificacoesAsRead(ids) {
        const mutation = gql`
        mutation MarkNotificacoesAsRead($ids: [String!]) {
            notificacoes: markNotificacoesAsRead(ids: $ids) {
                ${Notificacoes.notificacaoFields}
            }
        }
        `

        return this.gql
            .mutate(mutation, { ids })
            .then(({ notificacoes }) => notificacoes)
    }

    markTarefasAsRead(ids) {
        const mutation = gql`
        mutation MarkTarefasAsRead($ids: [String!]) {
            tarefas: markTarefasAsRead(ids: $ids) {
                ${Notificacoes.tarefaFields}
            }
        }
        `

        return this.gql
            .mutate(mutation, { ids })
            .then(({ tarefas }) => tarefas)
    }

    deleteAllNotificacoes() {
        const mutation = gql`
	    mutation DeleteAllNotificacoes {
		deleteAllNotificacoes
	    }
        `

        return this.gql
		   .mutate(mutation)
		   .then(() => true)
    }

    downloadAnexo(notificacao, anexo) {
        return cbk.download(`/api/notificacoes/download-anexo?notificacao=${notificacao.id}&anexo=${anexo.id}`)
    }

    imprimirNotificacao(notificacao) {
        const query = gql`
            query ImprimirNotificacao($id: String!) {
                usuarioAtual {
                    id
                    imprimirNotificacao(id: $id) {
                        token
                    }
                }
            }
        `

        return this.gql.query(query, { id: notificacao.id.toString() })
            .then((response) => response.usuarioAtual.imprimirNotificacao.token)
            .then((token) => this.downloadService.download(`/resume-operation/${token}`))
    }

    onCreateTarefa(usuarioId, callback) {
        const subscription = `
            subscription TarefaCreated($usuarioId: String!) {
                tarefa: tarefaCreated(usuarioId: $usuarioId) {
                    ${Notificacoes.tarefaFields}
                }
            }
        `

        return this.gql
            .subscribe(
                subscription,
                { usuarioId },
                ({ data: { tarefa } }) => callback(tarefa)
            )
    }

    onUpdateTarefa(usuarioId, callback) {
        const subscription = `
            subscription TarefaUpdated($usuarioId: String!) {
                tarefa: tarefaUpdated(usuarioId: $usuarioId) {
                    ${Notificacoes.tarefaFields}
                }
            }
        `

        return this.gql
            .subscribe(
                subscription,
                { usuarioId },
                ({ data: { tarefa } }) => callback(tarefa)
            )
    }

    onDeleteTarefa(usuarioId, callback) {
        const subscription = `
            subscription TarefaDeleted($usuarioId: String!) {
                tarefa: tarefaDeleted(usuarioId: $usuarioId) {
                    ${Notificacoes.tarefaFields}
                }
            }
        `

        return this.gql
            .subscribe(
                subscription,
                { usuarioId },
                ({ data: { tarefa } }) => callback(tarefa)
            )
    }

    onCreateNotificacao(usuarioId, callback) {
        const subscription = `
            subscription NotificacaoCreated($usuarioId: String!) {
                notificacao: notificacaoCreated(usuarioId: $usuarioId) {
                    ${Notificacoes.notificacaoFields}
                }
            }
        `

        return this.gql
            .subscribe(
                subscription,
                { usuarioId },
                ({ data: { notificacao } }) => callback(notificacao)
            )
    }

    onUpdateNotificacao(usuarioId, callback) {
        const subscription = `
            subscription NotificacaoUpdated($usuarioId: String!) {
                notificacao: notificacaoUpdated(usuarioId: $usuarioId) {
                    ${Notificacoes.notificacaoFields}
                }
            }
        `

        return this.gql
            .subscribe(
                subscription,
                { usuarioId },
                ({ data: { notificacao } }) => callback(notificacao)
            )
    }

    onDeleteNotificacao(usuarioId, callback) {
        const subscription = `
            subscription NotificacaoDeleted($usuarioId: String!) {
                notificacao: notificacaoDeleted(usuarioId: $usuarioId) {
                    ${Notificacoes.notificacaoFields}
                }
            }
        `

        return this.gql
            .subscribe(
                subscription,
                { usuarioId },
                ({ data: { notificacao } }) => callback(notificacao)
            )
    }
}

angular
    .module('eficienciaFiscalModule')
    .service('Notificacoes', Notificacoes)
